// user/* page translations
const user = {
  notice: {
    filter: {
      category: 'Danh mục',
      status: 'Trạng thái',
      all: 'Tất cả',
      categories: {
        system: 'Hệ thống',
        equipment: 'Thiết bị',
        quality: 'Chất lượng',
        alert: 'Cài đặt cảnh báo',
        education: 'Đào tạo',
        general: 'Chung',
      },
      statuses: {
        active: 'Đang đăng',
        waiting: 'Chờ',
        scheduled: 'Đã lên lịch',
        inactive: 'Vô hiệu',
        ended: 'Đã kết thúc',
      },
    },
    searchPlaceholder: 'Tìm theo tiêu đề, nội dung',
    addBtn: 'Đăng thông báo',
    col: {
      category: 'Danh mục',
      startDate: 'Ngày bắt đầu',
      endDate: 'Ngày kết thúc',
      title: 'Tiêu đề',
      author: 'Tác giả',
      priority: 'Ưu tiên',
      status: 'Trạng thái',
      views: 'Lượt xem',
      createdAt: 'Ngày tạo',
      action: 'Thao tác',
    },
    priority: {
      high: 'Cao',
      normal: 'Bình thường',
      low: 'Thấp',
    },
    addModal: {
      title: 'Đăng thông báo',
    },
    editModal: {
      title: 'Sửa thông báo',
    },
    form: {
      titleLabel: 'Tiêu đề',
      titlePlaceholder: 'Nhập tiêu đề thông báo',
      categoryLabel: 'Danh mục',
      priorityLabel: 'Ưu tiên',
      pinnedLabel: 'Ghim lên đầu',
      pinnedHint: 'Hiển thị trong header',
      startDateLabel: 'Ngày bắt đầu đăng',
      endDateLabel: 'Ngày kết thúc đăng',
      contentLabel: 'Nội dung',
      contentPlaceholder: 'Nhập nội dung thông báo',
    },
    actions: {
      register: 'Đăng',
      cancel: 'Hủy',
      update: 'Cập nhật',
      delete: 'Xóa',
    },
    seed: {
      defaultCategory: 'Thông báo',
      defaultAuthor: 'Quản trị viên',
    },
    deleteModal: {
      title: 'Xóa thông báo',
      message: 'Bạn có chắc muốn xóa "{title}"?\nHành động này không thể hoàn tác.',
      confirm: 'Xóa',
      cancel: 'Hủy',
    },
    alertDeleted: 'Đã xóa thông báo "{title}".',
    alertDeleteFail: 'Xóa thông báo thất bại.',
    alertTitleRequired: 'Vui lòng nhập tiêu đề.',
    alertContentRequired: 'Vui lòng nhập nội dung.',
    alertEndAfterStart: 'Ngày kết thúc phải sau ngày bắt đầu.',
    alertCreateSuccess: 'Tạo thông báo thành công.',
    alertCreateFail: 'Tạo thông báo thất bại.',
    alertUpdateSuccess: 'Cập nhật thông báo thành công.',
    alertUpdateFail: 'Cập nhật thông báo thất bại.',
  },
  role: {
    searchPlaceholder: 'Tìm tên vai trò, mã vai trò...',
    addBtn: 'Thêm vai trò',
    loading: 'Đang tải dữ liệu...',
    col: {
      name: 'Tên vai trò',
      code: 'Mã vai trò',
      count: 'Số quyền',
      scope: 'Phạm vi quyền',
      description: 'Mô tả',
      action: 'Thao tác',
    },
    countSuffix: '{n}',
    permissionCount: '({n})',
    permissionSelected: '(đã chọn {n})',
    misc: {
      etcCategory: 'Khác',
      noPermissions: 'Chưa cấu hình quyền.',
    },
    detailModal: {
      titleEdit: 'Sửa nhóm vai trò',
      titleView: 'Chi tiết nhóm vai trò',
      groupNameLabel: 'Tên nhóm vai trò',
      groupNamePlaceholder: 'Nhập tên nhóm vai trò',
      codeLabel: 'Mã vai trò',
      codePlaceholder: 'Nhập mã vai trò',
      descriptionLabel: 'Mô tả',
      descriptionPlaceholder: 'Nhập mô tả',
      permissionsLabel: 'Danh sách quyền',
      save: 'Lưu',
      cancel: 'Hủy',
      edit: 'Sửa',
      close: 'Đóng',
    },
    deleteModal: {
      title: 'Xóa nhóm vai trò',
      message: 'Bạn có chắc muốn xóa nhóm vai trò "{name}"?\nHành động này không thể hoàn tác.',
      confirm: 'Xóa',
      cancel: 'Hủy',
    },
    alertLoadFail: 'Tải dữ liệu thất bại.',
    alertUpdateSuccess: 'Đã cập nhật nhóm vai trò.',
    alertUpdateFail: 'Cập nhật nhóm vai trò thất bại.',
    alertDeleted: 'Đã xóa nhóm vai trò "{name}".',
    alertDeleteFail: 'Xóa nhóm vai trò thất bại. Có thể có người dùng đang sử dụng vai trò này.',
  },
  roleRegister: {
    title: 'Đăng ký vai trò',
    sectionBasic: 'Thông tin cơ bản',
    sectionPermissions: 'Cài đặt quyền',
    nameLabel: 'Tên vai trò',
    namePlaceholder: 'Nhập tên vai trò',
    codeLabel: 'Mã vai trò',
    codePlaceholder: 'VD: ADMIN, MANAGER',
    descriptionLabel: 'Mô tả',
    descriptionPlaceholder: 'Nhập mô tả vai trò',
    cancel: 'Hủy',
    submit: 'Đăng ký vai trò',
    alertNameRequired: 'Vui lòng nhập tên vai trò.',
    alertCodeRequired: 'Vui lòng nhập mã vai trò.',
    alertCreateSuccess: 'Đã đăng ký vai trò.',
    alertCreateFail: 'Đăng ký vai trò thất bại.',
    alertCodeDuplicate: 'Mã vai trò này đã được sử dụng.',
    alertLoadFail: 'Không thể tải danh sách quyền.',
    confirmCancel: 'Thay đổi chưa lưu sẽ bị mất. Hủy?',
  },
};

export default user;
